import React from 'react'
import { Inline } from '@/components/shared/atoms/layout/Inline'
import { TagBadge } from '@/components/frontend/atoms/content/TagBadge'
import { useTranslation } from '@/hooks/useTranslation'

interface TagItem {
  id: number
  name: string
  slug: string
}

interface TagFilterProps {
  tags: TagItem[]
  activeTag: string | null
}

export const TagFilter: React.FC<TagFilterProps> = ({ tags, activeTag }) => {
  const { lp } = useTranslation()

  if (tags.length === 0) return null

  return (
    <Inline gap="2" wrap>
      {tags.map((tag) => (
        <TagBadge key={tag.id} name={tag.name} slug={tag.slug} active={activeTag === tag.slug} basePath={lp('/blog')} />
      ))}
    </Inline>
  )
}
